// extracted by mini-css-extract-plugin
export default {"container":"signup_container__rAoLo","block":"signup_block__sG7cs","card":"signup_card__N6zZC","doubleInput":"signup_doubleInput__pvD18","streetNumber":"signup_streetNumber__9FvCn"};